export const defaultLangRedirectorCustomCountryLangMap: Record<string, string> = {
  at: 'de',
  be: 'fr'
};
